/* Categorielinks volgen het actieve geslachtsfilter. Dawn's facets.js wijzigt de URL met
   history.pushState zonder de categorielijst opnieuw te renderen; dit script leest de URL en
   zet de filterparameter op de categorielinks of haalt hem weg. */
(() => {
  if (customElements.get('bb-subcollections')) return;
  const PARAM = 'filter.v.t.shopify.target-gender';

  if (!window.__bbPushStatePatched) {
    window.__bbPushStatePatched = true;
    const original = history.pushState;
    history.pushState = function () {
      const result = original.apply(this, arguments);
      window.dispatchEvent(new Event('bb:urlchange'));
      return result;
    };
    window.addEventListener('popstate', () => window.dispatchEvent(new Event('bb:urlchange')));
  }

  class BBSubcollections extends HTMLElement {
    connectedCallback() {
      this.links = Array.from(this.querySelectorAll('.bb-subcollections__link'));
      this.onChange = () => this.sync();
      window.addEventListener('bb:urlchange', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('bb:urlchange', this.onChange);
    }

    sync() {
      // Alleen op categoriepagina's (data-follow-filter); landingspagina's houden hun vaste geslacht.
      if (this.dataset.followFilter !== 'true') return;
      const values = new URLSearchParams(window.location.search).getAll(PARAM);
      this.links.forEach((link) => {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        url.searchParams.delete(PARAM);
        values.forEach((value) => url.searchParams.append(PARAM, value));
        link.setAttribute('href', url.pathname + (url.search ? url.search : ''));
      });
    }
  }

  customElements.define('bb-subcollections', BBSubcollections);
})();
